$(document).ready(function(){
  let p5Swiper = new Swiper('#p5Swiper', {
    autoplay: true,//可选选项，自动滑动
    navigation: {
      nextEl: '.p5RightButton',
      prevEl: '.p5LeftButton',
    },
    pagination: {
      el: '.p5page',
    }
  })
  let p4Swiper = new Swiper('#p4Swiper', {
    autoplay: true,//可选选项，自动滑动
    navigation: {
      nextEl: '.p4RightButton',
      prevEl: '.p4LeftButton',
    },
    pagination: {
      el: '.p4page',
    }
  })
  let p3Swiper = new Swiper('#p3Swiper', {
    autoplay: true,//可选选项，自动滑动
    navigation: {
      nextEl: '.p3RightButton',
      prevEl: '.p3LeftButton',
    },
    pagination: {
      el: '.p3page',
    }
  })
  let p2Swiper = new Swiper('#p2Swiper', {
    autoplay: true,//可选选项，自动滑动
    navigation: {
      nextEl: '.p2RightButton',
      prevEl: '.p2LeftButton',
    },
    pagination: {
      el: '.p2page',
    }
  })
  let focus = new Swiper('.focus', {
    autoplay: true,//可选选项，自动滑动
    navigation: {
      nextEl: '.p1Left',
      prevEl: '.p1Right',
    }
  })
  let banner_1 = new Swiper('#banner_1', {
    autoplay: {
      delay: 4000,//1秒切换一次
    },
    direction: 'vertical'
  })
  let banner_2 = new Swiper('#banner_2', {
    autoplay: {
      delay: 4000,//1秒切换一次
    },
    direction: 'vertical'
  })
  let banner_3 = new Swiper('#banner_3', {
    autoplay: {
      delay: 4000,//1秒切换一次
    },
    direction: 'vertical'
  })
  let banner_4 = new Swiper('#banner_4', {
    autoplay: {
      delay: 4000,//1秒切换一次
    },
    direction: 'vertical'
  })
})